<mat-spinner [strokeWidth]="4" [diameter]="45" color="accent"></mat-spinner>
